export const formatAmount = (amount) =>
  new Intl.NumberFormat('en-US', { style: 'currency', currency: 'USD' }).format(amount || 0);

// Handles both ISO timestamps ("2025-05-08T...") and plain date strings ("2025-05-08")
// Adding T12:00:00 to plain dates avoids UTC midnight off-by-one-day issues
export const formatDate = (dateStr, opts) => {
  if (!dateStr) return '—';
  const d = String(dateStr).length === 10
    ? new Date(dateStr + 'T12:00:00')
    : new Date(dateStr);
  return d.toLocaleDateString('en-US', opts ?? { month: 'short', day: 'numeric', year: 'numeric' });
};

export const formatDateLong = (dateStr) =>
  formatDate(dateStr, { month: 'long', day: 'numeric', year: 'numeric' });

export const nextInvoiceNumber = (invoices) => {
  const last = invoices?.[0]?.invoice_number ?? 'INV-000';
  const n = parseInt(last.replace('INV-', ''), 10) || 0;
  return `INV-${String(n + 1).padStart(3, '0')}`;
};
